import React from "react";

export default function LoadingScreen() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-700">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 mb-4"></div>
      <p>Loading the best deals...</p>
    </div>
  );
}
